/**
 * 理论 / 实操题型标签配色
 * 浅底 + 深色字 + 同色描边，便于列表中快速区分题型
 */

/** @typedef {{ color: string, background: string, borderColor: string }} TagColor */

/** 理论题型：theory_type */
export const THEORY_TYPE_COLORS = {
  1: {
    color: "#4338CA",
    background: "#EEF2FF",
    borderColor: "#C7D2FE"
  }, // 单选题 — 靛蓝
  2: {
    color: "#B45309",
    background: "#FFFBEB",
    borderColor: "#FDE68A"
  }, // 判断题 — 琥珀
  3: {
    color: "#6D28D9",
    background: "#F5F3FF",
    borderColor: "#DDD6FE"
  }, // 多选题 — 紫罗兰
  4: {
    color: "#0E7490",
    background: "#ECFEFF",
    borderColor: "#A5F3FC"
  }, // 填空题 — 青
  5: {
    color: "#BE123C",
    background: "#FFF1F2",
    borderColor: "#FECDD3"
  } // 简答题 — 玫红
};

/** 实操题型：practical_type */
export const PRACTICAL_TYPE_COLORS = {
  1: {
    color: "#1D4ED8",
    background: "#EFF6FF",
    borderColor: "#BFDBFE"
  }, // 图像分类 — 蓝
  2: {
    color: "#0F766E",
    background: "#F0FDFA",
    borderColor: "#99F6E4"
  }, // 图像标注 — 青绿
  3: {
    color: "#C2410C",
    background: "#FFF7ED",
    borderColor: "#FED7AA"
  }, // 视频识别 — 橙
  4: {
    color: "#BE185D",
    background: "#FDF2F8",
    borderColor: "#FBCFE8"
  }, // 音频识别 — 粉
  5: {
    color: "#15803D",
    background: "#F0FDF4",
    borderColor: "#BBF7D0"
  }, // 时序检测 — 绿
  6: {
    color: "#475569",
    background: "#F8FAFC",
    borderColor: "#CBD5E1"
  }, // 简答题 — 灰蓝
  7: {
    color: "#7E22CE",
    background: "#FAF5FF",
    borderColor: "#E9D5FF"
  } // 图像分割 — 紫
};

const COLOR_BY_DICT = {
  theory_type: THEORY_TYPE_COLORS,
  practical_type: PRACTICAL_TYPE_COLORS
};

/**
 * @param {string} dictType
 * @param {string|number} value
 * @returns {TagColor|null}
 */
export function getQuestionTypeColor(dictType, value) {
  const palette = COLOR_BY_DICT[dictType];
  if (!palette || value === null || value === undefined || value === "") {
    return null;
  }
  return palette[String(value)] || palette[Number(value)] || null;
}



// WEBPACK FOOTER //
// ./src/utils/questionTypeColors.js